<!-- ============================================================
     Reusable photo card
     ctx: img, label, caption, index, exifName, hasExif, isMulti
     ============================================================ -->
<ng-template #photoCard let-img="img" let-label="label" let-caption="caption"
             let-index="index" let-exifName="exifName" let-hasExif="hasExif"
             let-isMulti="isMulti">
  <div class="rp-card"
       (mouseenter)="hasExif && onImageHover(exifName)"
       (mouseleave)="hasExif && onImageLeave()">

    <div class="rp-card__frame">
      <img class="rp-card__img" [src]="img" [alt]="caption || label" loading="lazy"
           (click)="openBigModal(img, caption, index)">

      <div class="rp-card__label" [class.rp-card__label--multi]="isMulti">
        <span>{{ label }}</span>
      </div>

      <div class="rp-card__overlay" *ngIf="hasExif">
        <div class="rp-card__exif">
          <div class="rp-card__exif-date">{{ currentExifDate }}</div>
          <div class="rp-card__exif-row">{{ currentExifLatitude }}</div>
          <div class="rp-card__exif-row">{{ currentExifLongitude }}</div>
        </div>
      </div>

      <button *ngIf="hasExif" class="rp-mapbtn"
              (click)="openMapForImage(exifName, img, caption); $event.stopPropagation()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          <path stroke-linecap="round" stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
        </svg>
        Map
      </button>
    </div>
  </div>
</ng-template>


<div class="rp-root">

  <!-- ---------- Header ---------- -->
  <div class="rp-header">
    <button class="rp-header__close" (click)="close()" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
           stroke-width="1.8" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
    <div class="rp-header__titles">
      <span class="rp-header__title">Rating Photos</span>
      <span class="rp-header__loc" *ngIf="locAddress" [title]="locAddress">{{ locAddress }}</span>
      <span class="rp-header__locsub" *ngIf="locDetail" [title]="locDetail">{{ locDetail }}</span>
      <span class="rp-header__sub" *ngIf="!locAddress && !locDetail">Tap or click any photo to enlarge it</span>
    </div>
    <span class="rp-header__accent"></span>
  </div>

  <!-- ---------- Scrollable body ---------- -->
  <div class="rp-body">

    <!-- Elevations -->
    <section class="rp-section" *ngIf="elevPhotos?.length">
      <div class="rp-section__head">
        <span class="rp-section__title">Elevations</span>
      </div>
      <div class="rp-grid">
        <ng-container *ngFor="let item of elevPhotos; let i = index;">
          <ng-container *ngIf="item.image"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{ img: item.image, label: item.name, caption: item.name, index: i, exifName: item.name, hasExif: true }">
          </ng-container>
        </ng-container>
      </div>
    </section>

    <!-- Rating photos -->
    <section class="rp-section" *ngIf="photoData?.length">
      <div class="rp-section__head">
        <span class="rp-section__title">Rating Photos</span>
      </div>
      <div class="rp-grid">
        <ng-container *ngFor="let item of photoData; let i = index;">
          <!-- multi-photo field: render every formpics photo inline at its natural position -->
          <ng-container *ngFor="let photoUrl of item.photos; let p = index;"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{
              img: photoUrl,
              label: item.photos.length > 1 ? item.name + ' ' + (p + 1) : item.name,
              caption: item.name,
              index: p,
              exifName: item.name + '_photo_' + p,
              hasExif: true,
              isMulti: item.photos.length > 1
            }">
          </ng-container>
          <!-- single legacy photo (fields with no loaded formpics set) -->
          <ng-container *ngIf="!item.photos?.length && item.image && item.name != 'id' && item.name != 'job_id' && item.name != 'elevphotos' && item.name != 'location_id'"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{ img: item.image, label: item.name, caption: item.name, index: i, exifName: item.name, hasExif: true }">
          </ng-container>
        </ng-container>
      </div>
    </section>

    <!-- Multifamily / ESMFNC -->
    <section class="rp-section" *ngIf="esmfnc?.length || multifamily?.length">
      <div class="rp-section__head">
        <span class="rp-section__title">Multifamily / ESMFNC</span>
      </div>
      <div class="rp-grid">
        <ng-container *ngFor="let item of esmfnc; let i = index;">
          <!-- primary photo -->
          <ng-container *ngIf="item.image"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{ img: item.image, label: item.name, caption: item.name, index: i, exifName: item.name, hasExif: true }">
          </ng-container>
          <!-- additional photos -->
          <ng-container *ngFor="let photo of item.photos; let p = index;"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{ img: photo, label: item.name + ' (' + (p + 1) + ')', caption: item.name + ' (photo ' + (p + 1) + ')', index: p, exifName: item.name + '_photo_' + p, hasExif: true, isMulti: true }">
          </ng-container>
        </ng-container>

        <!-- multifamily template photos -->
        <ng-container *ngFor="let item of multifamily; let i = index;">
          <ng-container *ngIf="item.image"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{ img: item.image, label: item.fieldname || 'Multifamily', caption: item.fieldname, index: i, hasExif: false }">
          </ng-container>
        </ng-container>
      </div>
    </section>

    <!-- Energy Star -->
    <section class="rp-section" *ngIf="checklistPhotosOnly?.length">
      <div class="rp-section__head">
        <span class="rp-section__title">Energy Star Photos</span>
      </div>
      <div class="rp-grid">
        <ng-container *ngFor="let item of checklistPhotosOnly">
          <ng-container *ngFor="let image of item.photos; let p = index;"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{ img: image, label: item.photos.length > 1 ? item.field + ' (' + (p + 1) + ')' : item.field, caption: item.description, index: p, exifName: item.name, hasExif: true, isMulti: item.photos.length > 1 }">
          </ng-container>
        </ng-container>
      </div>
    </section>

    <!-- HVAC Grading (per-system volts/amps/lineset photos + airflow report PDF) -->
    <section class="rp-section" *ngIf="hvacGradingGroups?.length">
      <div class="rp-section__head">
        <span class="rp-section__title">HVAC Grading Photos</span>
      </div>
      <div class="rp-grid">
        <ng-container *ngFor="let group of hvacGradingGroups">
          <ng-container *ngFor="let photo of group.photos; let i = index;"
            [ngTemplateOutlet]="photoCard"
            [ngTemplateOutletContext]="{ img: photo.url, label: photo.label, caption: photo.label, index: i, exifName: photo.exifName, hasExif: true }">
          </ng-container>
        </ng-container>
      </div>
      <div class="rp-pdf-row" *ngIf="hasAirflowReports">
        <ng-container *ngFor="let group of hvacGradingGroups">
          <a *ngIf="group.pdf" class="rp-pdf-link" [href]="group.pdf" target="_blank" rel="noopener">
            {{ group.label }} Airflow Report (PDF)
          </a>
        </ng-container>
      </div>
    </section>

    <!-- Job Conditions -->
    <section class="rp-section" *ngIf="jobCondPics?.length">
      <div class="rp-section__head">
        <span class="rp-section__title">Job Conditions</span>
      </div>
      <div class="rp-grid">
        <ng-container *ngFor="let item of jobCondPics; let i = index;"
          [ngTemplateOutlet]="photoCard"
          [ngTemplateOutletContext]="{ img: item.imgref, label: item.caption, caption: item.caption, index: i, hasExif: false }">
        </ng-container>
      </div>
    </section>

    <!-- Selfie -->
    <section class="rp-section">
      <div class="rp-section__head">
        <span class="rp-section__title">Selfie Photos</span>
      </div>
      <div class="rp-loading" *ngIf="selfieLoading">
        <mat-spinner diameter="38"></mat-spinner>
      </div>
      <div class="rp-empty" *ngIf="!selfieLoading && selfiePhotos.length === 0">
        No selfie photos found.
      </div>
      <div class="rp-grid" *ngIf="selfiePhotos.length > 0">
        <ng-container *ngFor="let selfie of selfiePhotos; let i = index;"
          [ngTemplateOutlet]="photoCard"
          [ngTemplateOutletContext]="{ img: selfie.image_url, label: 'Selfie', caption: 'Selfie', index: i, exifName: selfie.name, hasExif: true }">
        </ng-container>
      </div>
    </section>

  </div>

</div>
